module.exports = __webpack_public_path__ + "img/Malta.976a9444.svg";